<template>
  <div>
    <el-dialog :title="this.$i18.language('国家/地区')" class="country-dialog el-body-contry-dialog" :modal-append-to-body="false" :close-on-click-modal="false" :append-to-body="true" :visible.sync="countryVisible">
      <div class="data-types">
        <div>
          <el-checkbox v-model="multipleCompany" @change="changeMultipleCompany">{{ $t('search.multipleCompany') }}</el-checkbox>
        </div>
      </div>
      <div class="country-select">
        <div class="dialogheig">
          <button-select :multipleCompany="multipleCompany" :data="countryData" :value="selectCountryData" :single="false" @change-select-all="changeSelectAll" @change-select="changeCountry"></button-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="multipleCompany">
        <el-button size="mini" class="sub-confirm-btn" @click="cancelCountry">{{ $t('cancel') }}</el-button>
        <el-button size="mini" class="confirm-btn" @click="confirmCountry">{{ $t('sure') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ButtonSelect from '@/components/ButtonSelect.vue'
export default {
  name: 'countrySelect',
  components: {
    ButtonSelect,
  },
  props: {
    dashSub: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectCountryData() {
      return this.tempParams.countryIds
    },
  },
  data() {
    return {
      countryVisible: false,
      countryData: [],
      countrytdata: [],
      // 判断多选国家搜索功能是否开启
      multipleCompany: false,
      // 消息订阅
      msgStatus: true,
      countryName: '',
      tempParams: {
        companyNames: '',
        countryIds: [],
      },
    }
  },

  mounted() {},

  methods: {
    // 切换国家多选标志
    changeMultipleCompany() {
      this.tempParams.countryId = 0
      this.tempParams.countryIds = []
      this.countryData = this.countryData.map((item) => {
        this.$set(item, 'checked', false)
        this.$set(item, 'isIndeterminate', false)
        item.children = item.children.map((val) => {
          this.$set(val, 'checkout', false)
          return val
        })
        return item
      })
    },
    // 国家/地区全览全选操作
    changeSelectAll({ checked, data }) {
      let countrys = this.tempParams.countryIds,
      countryIds = []
      data.children.forEach((item) => {
        let index = countrys.findIndex((val) => val == item.value)
        if (item.checkout&&item.isOpen) countryIds.push(item.value)
        if (index > -1 && item.checkout === false) countrys.splice(index, 1)
      })
      //判断当前当前国家是否能访问
      // let addCountryidex = data.children.filter((item) => item.isOpen!= false)
      // console.log(addCountryidex)
      // if (addCountryidex >= 0) {
      //   this.$message({
      //     message: this.$t('message.noPermission'),
      //     type: 'warning',
      //   })
      // } else {
        this.tempParams.countryIds = Array.from(new Set([...countryIds, ...countrys]))
      // }

      this.checkboxStatus(data)
    },
    // 处理筛选框半选全选操作
    checkboxStatus(data) {
      let checkedCount = data.children.filter(item=>this.tempParams.countryIds.includes(item.value)).length
      let lengthOrig =  data.children.filter(i=>i.isOpen==true).length
      this.$set(data, 'isIndeterminate',  (checkedCount>0 &&checkedCount < lengthOrig) )
      this.$set(data, 'checked',  checkedCount==lengthOrig )
      return data
    },
    changeCountry(item) {
      this.countryUrl = item.flag
      this.tempParams.countryId = item.value
      this.countryName = item.label
      this.tempParams.countryIds = [item.value]
      this.confirmCountry()
    },
    openCountrySelect(data) {
      this.tempParams = data
      let { countryId, countryIds } = JSON.parse(JSON.stringify(data))
      // if (this.params.countryId != null) {
        this.tempParams.countryId = countryId
        this.tempParams.countryIds = countryIds
        if (countryIds && countryIds.length > 1) {
          this.multipleCompany = true
          this.countryData = this.countryData.map((item) => this.checkboxStatus(item))
        } else {
          this.multipleCompany = false
        }
        this.countryVisible = true
      // }
    },

    cancelCountry() {
      this.countryVisible = false
    },

    confirmCountry() {
      let {countryIds} = this.tempParams
      if(countryIds&&countryIds.length>0){
        let countryData = this.countryData.flatMap(item=>item.children)
        let obj = countryData.find((item) => item.value === countryIds[0]) 
        this.countryName = countryIds.length>1 ? this.$t('search.multipleCompanyTag'):obj ? obj.label : this.$t('leftFilter.allCountry')
        let sendParams = {
          patteguojia: this.countryName,
          patteguid: this.tempParams.countryIds,
        }
        this.$emit('changeCountryF', sendParams)
        this.countryVisible = false
      } else {
        this.$message.warning(this.$t('search.selectCountry'))
      }
      
      
    },
  },
}
</script>

<style lang="scss" scoped>
.country-select {
  padding: 20px 10px;
  .btn-group {
    text-align: right;
  }
}
/deep/.cancel-btn:hover {
  background: rgba(234, 85, 25, 0.1) !important;
  border-color: transparent !important;
  color: #ea5519 !important;
}
.dialogheig {
  height: 50vh;
  overflow: auto;
}
.moreSelect {
  position: absolute;
  top: 17px;
  left: 127px;
}
</style>